/* eslint-disable react/function-component-definition */
import React from 'react';
import { useAuth } from 'react-oidc-context';

import {
  LINK_CPTA_TERMS_OF_USE,
  LINK_CPTA_FAIR,
  LINK_CPTA_WORKSPACE_WEST_EUROPE,
  LINK_ARIDHIA_KB,
  LINK_ARIDHIA_CONTACT_SD,
  LINK_ARIDHIA_PRIVACY_POLICY,
} from 'env-create-react-app';

import CPTALogoColour from '../images/cpath_logo_colour.svg';
import CPTALogoWhite from '../images/cpath_logo_white.svg';
import defaultUserIcon from '../images/default-user-icon.png';
import FAIRLogo2020Baby from '../images/FAIRLogo2020-baby.svg';
import workspaceLogo2020Baby from '../images/ws-baby.svg';

import { SignInButton } from './SignInButton';
import { SignOutButton } from './SignOutButton';

const getInitials = (text) => {
  if (!text) return '';
  const parts = text.trim().split(/\s+/);
  if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
  return parts[0][0].toUpperCase();
};

const avatarBackgroundColour = (name) => {
  const colours = [
    '#E9421E',
    '#B6271B',
    '#850F19',
    '#6E1932',
    '#562150',
    '#2C2A4C',
    '#0C3247',
    '#1B5A72',
    '#2C88A2',
    '#34867A',
    '#3C8556',
    '#5B8C41',
    '#7E922F',
    '#9EAE02',
    '#BE8C00',
    '#995F19',
  ];

  const clean = (name || '').toLowerCase();
  const vowels = (clean.match(/[aeiou]/gi) || []).length;
  const index = (clean.length + vowels) % colours.length;

  return colours[index];
};

const ProfileContent = () => {
  const auth = useAuth();
  const { isAuthenticated, user } = auth;
  if (isAuthenticated) {
    const userName = `${user?.profile?.given_name} ${user?.profile?.family_name}`;
    const userInitials = getInitials(userName);
    return (
      <>
        {userName}
        <img
          id="avatar"
          src={defaultUserIcon}
          style={{ backgroundColor: avatarBackgroundColour(userName) }}
          alt="User profile"
          className="ui mini right floated image"
          size="mini"
        />
        <div className="avatar-initials">{userInitials}</div>
        <div className="meta" />
      </>
    );
  }
  return (
    <>
      Please sign in
      <img id='avatar' src={defaultUserIcon} alt='User profile' className='ui mini right floated image' size='mini' style={{ backgroundColor: 'rgb(102, 102, 102)' }} />
      <div className="avatar-initials" />
      <div className="meta" />
    </>
  );
};

const Header = () => {
  const auth = useAuth();
  const { isLoading, isAuthenticated } = auth;
  if (isLoading) {
    return null; // or a loading spinner
  }

  return (
    <div id="header" className="semantic">
      <div className="ui inverted nav fixed menu">
        <div className="ui container">
          <a href="/" className="header item logo">
            <img src={CPTALogoColour} alt="Aridhia Logo" className="ui image logo" id="portalLogo" />
            <img src={CPTALogoWhite} alt="Aridhia Logo" className="ui image logo" id="portalLogoHover" />
          </a>
          <a href={LINK_CPTA_FAIR} target="_blank" rel="noreferrer" className="item menu">
            <img src={FAIRLogo2020Baby} alt="" className="icon" />
            <img src={FAIRLogo2020Baby} alt="" className="icon hover" />
            {' '}
            Data Services
          </a>
          <a href={LINK_CPTA_WORKSPACE_WEST_EUROPE} target="_blank" rel="noreferrer" className="item menu">
            <img src={workspaceLogo2020Baby} alt="" className="icon" />
            <img src={workspaceLogo2020Baby} alt="" className="icon hover" />
            {' '}
            Workspaces
          </a>
          <div className="right menu">
            <div className="item help">
              <a className="knowledgebase" href={LINK_ARIDHIA_KB} target="_blank" rel="noopener noreferrer" data-tooltip="Visit the Aridhia DRE Knowledge Base" data-variation="mini" data-position="bottom center">
                <span className="visuallyhidden">Visit the Aridhia DRE Knowledge Base</span>
                <i aria-hidden="true" className="question circle outline large inverted icon" />
              </a>
            </div>
            <div className="ui simple dropdown item">
              <div id="user_name_display" className="header">
                <ProfileContent />
              </div>
              <div className="menu">
                <a href={LINK_ARIDHIA_PRIVACY_POLICY} target="_blank" rel="noopener noreferrer" role="option" aria-selected="true" className="item">
                  <i aria-hidden="true" className="shield icon" />
                  Privacy
                </a>
                <a href={LINK_CPTA_TERMS_OF_USE} target="_blank" rel="noopener noreferrer" role="option" aria-selected="false" className="item">
                  <i aria-hidden="true" className="handshake solid icon" />
                  Terms &amp; conditions
                </a>
                <a href={LINK_ARIDHIA_CONTACT_SD} target="_blank" rel="noopener noreferrer" role="option" aria-selected="false" className="item">
                  <i aria-hidden="true" className="heart icon" />
                  Feedback
                </a>
                <div className="divider" />
                {isAuthenticated ? (
                  <SignOutButton className='header-auth' />
                ) : (
                  <SignInButton className='header-auth' />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
